module.exports = __webpack_public_path__ + "img/logo-new-dx.d5a10298.png";